module.exports = __webpack_public_path__ + "media/images/favicons/mstile-150x150-4f48ec5dcbe68b8a434ea27a3fa0c628.png";